import styled from 'styled-components';

// Proposed AI-brand exception: preserve this decorative gradient/glow pending
// design approval and authenticated light/dark screenshots.
const AI_ENTRY_POINT_DECORATION = {
  gradient:
    'linear-gradient(263deg, rgba(3, 42, 62, 0.14) -2.47%, rgba(110, 190, 230, 0.30) 60.36%, rgba(3, 42, 62, 0.17) 88.61%), linear-gradient(17deg, rgba(18, 145, 208, 0.20) 10.25%, rgba(72, 208, 140, 0.10) 41.63%, rgba(255, 255, 255, 0.00) 63.43%)',
  glow: '0 0 16px rgba(15, 120, 173, 0.6), 0 0 32px rgba(15, 120, 173, 0.5), 0 0 64px rgba(15, 120, 173, 0.4), 0 0 96px rgba(15, 120, 173, 0.3)',
} as const;

export const EntryPointWrapper = styled.div(
  ({ theme }) => `
    display: flex;
    padding: ${theme.spacing[5]}px;
    align-items: center;
    gap: ${theme.spacing[3]}px;
    border-bottom-left-radius: ${theme.border.radius.max}px;
    border-bottom-right-radius: ${theme.border.radius.max}px;
    border-top-left-radius: ${theme.border.radius.max}px;
    border-top-right-radius: ${theme.border.radius.max}px;
    overflow: hidden;
    background: ${AI_ENTRY_POINT_DECORATION.gradient}, ${theme.colors.surface.background.gray.moderate};
    box-shadow: ${AI_ENTRY_POINT_DECORATION.glow};
`,
);

export const SuggestionCard = styled.button(
  ({ theme }) => `
    display: flex;
    padding: ${theme.spacing[3]}px;
    align-items: center;
    width: 100%;
    background-color: ${theme.colors.surface.background.gray.intense};
    border: ${theme.border.width.thin}px solid ${theme.colors.surface.border.gray.muted};
    border-radius: ${theme.border.radius.medium}px;
    cursor: pointer;
    transition: all ${theme.motion.duration.quick}ms ${theme.motion.easing.emphasized};
    text-align: left;

    &:hover {
      background-color: ${theme.colors.surface.background.gray.moderate};
      border-color: ${theme.colors.interactive.border.gray.default};
    }

    &:active {
      transform: scale(0.98);
    }
`,
);
